let activeRoomId = null;

export function setActiveRoomId(roomId) {
  activeRoomId = roomId || null;
  try {
    if (activeRoomId) localStorage.setItem('tchat_active_room', activeRoomId);
    else localStorage.removeItem('tchat_active_room');
  } catch (_) {}
}

export function getActiveRoomId() {
  if (activeRoomId) return activeRoomId;
  try {
    const v = localStorage.getItem('tchat_active_room');
    return v || null;
  } catch (_) {
    return null;
  }
}


